import { inject, Injector } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { PlatformService } from '@sml/utility';
import { from, map, switchMap } from 'rxjs';
import { UserRoleEnum } from '../enums/userrole.enum';
import { StorytellerSignalSignalService } from '../services/storyteller/storyteller.signal.service';

export const StorytellerResolver: ResolveFn<boolean> = (
  route: ActivatedRouteSnapshot
) => {
  const platformService = inject(PlatformService);
  const injector = inject(Injector);
  const storytellerSignalSignalService = inject(StorytellerSignalSignalService);
  const byPassRoles = [UserRoleEnum.IndividualStoryteller];

  if (!platformService.browser()) return false;

  return from(import('@auth0/auth0-angular')).pipe(
    map((module) => module.AuthService),
    switchMap((AuthService) => {
      const service = injector.get(AuthService);
      return service.user$;
    }),
    map((user) => {
      // Actual logic will be implemented here
      if (byPassRoles.includes(user?.['https://seemylegacy.com/sml_role'])) {
        storytellerSignalSignalService.signalIsValidStoryteller.set(true);
        return true;
      } else {
        storytellerSignalSignalService.signalIsValidStoryteller.set(false);
        return false;
      }
    })
  );
};
